import React from 'react';

import classes from './LibraryPanelDetailsTab.module.scss';
import { Input } from '@DesignSystem/controllers';
import usePanelTemplate from '@/experiment-management-shared/api/library-panel/usePanelTemplate';
import { useLocation } from 'react-router';
import { getURLQueryParams } from '@shared/utils/url';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { getChartFormByType } from '@/reducers/dashboardChartsReducer';
import dashboardChartsActions from '@/actions/dashboardChartsActions';
import { BUILT_IN_CHART_TYPES } from '@/experiment-management-shared/constants';
import isEmpty from 'lodash/isEmpty';

const LibraryPanelDetailsTab = () => {
  const location = useLocation();
  const queryParams = getURLQueryParams(location.hash);
  const templateId = queryParams.get('templateId');
  const revisionId = queryParams.get('revisionId');

  const isPreview = queryParams.get('isPreview') === 'true';

  const dispatch = useDispatch();

  const chartForm = useSelector(state =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /* @ts-ignore */
    getChartFormByType(state, { chartType: BUILT_IN_CHART_TYPES.libraryPanel })
  );

  const { data: template } = usePanelTemplate({
    templateId: templateId || '',
    revisionId
  });

  const handleUpdateFormKey = (key: string, value: string) => {
    dispatch(
      dashboardChartsActions.updateChartFormKey(
        BUILT_IN_CHART_TYPES.libraryPanel,
        key,
        value
      )
    );
  };

  if (!template) return null;

  return (
    <div className={classes.detailsTabContainer}>
      <Input
        onChange={(value: string) => handleUpdateFormKey('chartName', value)}
        title={<b>Name</b>}
        disabled={isPreview}
        value={chartForm.chartName}
      />
      <Input
        multiline
        onChange={(value: string) => handleUpdateFormKey('description', value)}
        height="100px"
        disabled={isPreview}
        title={<b>Description</b>}
        value={
          isEmpty(chartForm.description)
            ? template.code.description
            : chartForm.description
        }
      />
      <div className={classes.revisionDetailsContainer}>
        <p>
          <b>Created by</b>: {template?.owner}
        </p>
        <p>
          <b>Created at</b>: {format(template.createdAt, 'MM/dd/yyyy hh:mm a')}
        </p>
        <p>
          <b>Last updated</b>:
          {format(template?.revisionId, 'MM/dd/yyyy hh:mm a')}
        </p>
      </div>
    </div>
  );
};

export default LibraryPanelDetailsTab;
